<div class="wrapper">
  <img class="spinner" alt="auxilia spinner" src="../../../assets/images/Spinner_2_28-px.gif"/>
</div>
